import { button } from '../../../../../component/component'

export default function(o,c){

  var prev =
    button(null,'fi-previous')

  return prev

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/prev/prev.js